import { render, staticRenderFns } from "./AdminBanner.vue?vue&type=template&id=b2c6b4d8&scoped=true&"
import script from "./AdminBanner.vue?vue&type=script&lang=js&"
export * from "./AdminBanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2c6b4d8",
  null
  
)

export default component.exports